<div *ngIf = "policy.declined">
<div class="modal-header">
  <h5 class="modal-title">{{title}}</h5>
</div>
<div class="modal-body">
  <p [innerHTML]="text"></p>
</div>
</div>

<div *ngIf="policy.notBinding">
<div class="modal-header">
  <h5 class="modal-title"> {{DoNotBindText}}</h5>
</div>
<div class="modal-body">
  <div [innerHTML]="notBindingInfo.reason"></div>
  <p class="do-not-bind">{{notBindingInfo.phoneNumber}}</p>
</div>
</div>